import { ItemType } from '../api-types/enums/item-type';
export const LIBRARY_VIDEO_TYPES = [ItemType.Item, ItemType.ItemLiveFinalize];
export const LIVE_LIBRARY_VIDEO_TYPES = [ItemType.ItemLive, ItemType.ItemScheduled];
//# sourceMappingURL=video-item-types.js.map